import React from 'react'
import * as THREE from 'three';
import { Link, withRouter } from 'react-static'
import styles from './styles.module.css'

let renderer = null;

class Logo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            threeInit: false
        }
    }

    componentDidMount() {
        this.initScene()
        this.initModel()
        this.setState({
            threeInit: true
        })
    }

    initScene() {
        this.scene = new THREE.Scene();
        
        if (!renderer) {
            renderer = new THREE.WebGLRenderer({ 
                antialias: true , alpha: true 
            });
        }

        this.renderer = renderer

        this.renderer.setPixelRatio(window.devicePixelRatio)
        // TODO make this dynamic to the col width
        this.renderer.setSize( 200, 200 )
        this.renderer.toneMappingExposure = 2.0
        this.renderer.setClearColor(0x000000, 0)

        this.camera = new THREE.PerspectiveCamera( 40, 1.0, 0.1, 100 )

        this.camera.position.z = 5.0
        this.camera.position.x = 0.1

        let ambLight = new THREE.AmbientLight(0x111727)
        this.scene.add(ambLight)

        let pointLight = new THREE.PointLight(0x00E1E7)
        pointLight.intensity = 0.1
        pointLight.position.x = 10
        pointLight.position.y = 10
        pointLight.position.z = 70

        this.scene.add(pointLight)

        this.mouseLight = new THREE.PointLight(0x00E1E7)
        this.mouseLight.intensity = 0.1
        this.scene.add(this.mouseLight)
        this.mouseLight.position.z = 70
        this.mouseLight.rotation.y = -2.0

        this.mount.appendChild(this.renderer.domElement)

        this.renderer.domElement.addEventListener('mousemove', (e) => { this.mouseMove(e) }, false)
    }

    initModel() {
        let loader = new THREE.JSONLoader()

        loader.load('/hashbang.json', (geometry, materials) => {
            this.logo = new THREE.Mesh(geometry, materials)
            this.scene.add(this.logo)
            this.renderer.animate(this.animate.bind(this))
        })
    }

    animate() {
        this.renderer.render(this.scene, this.camera)
    }

    goHome(e) {
        this.props.history.push("/")
        e.preventDefault()
    }

    mouseMove(e) {
        this.mouseLight.position.x = (e.clientX - this.renderer.domElement.offsetLeft) / 5.0
        this.mouseLight.position.y = -5.0 -(e.clientY - this.renderer.domElement.offsetTop) / 5.0
    }

    render() {
        return <h1 className={styles.logo} ref={(mount) => { this.mount = mount }} onClick={(e) => { this.goHome(e) }}>
            { this.state.threeInit ? <span /> : <Link to="/">#!</Link> }
        </h1>
    }
}

export default withRouter(Logo)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/Logo/index.js